module.exports = __webpack_public_path__ + "img/check.8bf2ceda.svg";